import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-27c66c06")

_pushScopeId("data-v-27c66c06")
const _hoisted_1 = { class: "app-menu" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, "   FAQ", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "   My Account", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("ul", null, [
      _createVNode("li", null, [
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.goToFAQ()))
        }, [
          _hoisted_2
        ])
      ]),
      _createVNode("li", null, [
        _createVNode("button", {
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.logout()))
        }, [
          _hoisted_3
        ])
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.show]
  ])
})